import React from 'react';
import { GlassCard } from '../../../_shared/GlassCard';
import { MONTHS, formatNum } from '../data';

const maxViews = Math.max(...MONTHS.map(m => m.views));

const MonthRow = ({ m }) => {
    const pct = Math.max(4, Math.round((m.views / maxViews) * 100));
    return (
        <div className="py-5 border-b border-white/10 last:border-b-0">
            <div className="flex items-baseline justify-between mb-2 gap-3 flex-wrap">
                <div className="flex items-center gap-3">
                    <p className="text-white font-bold text-sm md:text-base tracking-tight">{m.label}</p>
                    <span className="inline-flex items-center bg-purple-500/15 text-purple-300 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider">
                        {m.tag}
                    </span>
                </div>
                <div className="flex items-baseline gap-4">
                    <p className="text-white font-black text-lg md:text-xl tracking-tight">{formatNum(m.views)} <span className="text-white/40 text-xs font-semibold">views</span></p>
                    <p className="text-white/50 text-xs font-mono">{formatNum(m.posts)} posts</p>
                </div>
            </div>
            <div className="h-2 rounded-full bg-white/5 overflow-hidden">
                <div
                    className="h-full rounded-full bg-gradient-to-r from-purple-500/60 to-blue-400/60"
                    style={{ width: `${pct}%` }}
                />
            </div>
            <p className="text-white/40 text-xs mt-2">{m.note}</p>
        </div>
    );
};

export const MonthByMonth = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-4xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">Month By Month</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">
                    How The Engine Ramped
                </h2>
                <p className="text-white/50 text-center mb-12 max-w-xl mx-auto">
                    Views earned by the content published in each period, measured Jul 7.
                </p>

                <GlassCard>
                    <div className="px-2">
                        {MONTHS.map((m, i) => <MonthRow key={i} m={m} />)}
                    </div>
                </GlassCard>

                <p className="text-white/30 text-xs text-center mt-6 max-w-2xl mx-auto">
                    Dated posts only; excludes 12,260 undated YouTube fan-channel views. Early-window counts are measured floors.
                </p>
            </div>
        </section>
    );
};
